/* Prepared for DEV integration. No ecommerce purchase emitter or storage. */
(function () {
  'use strict';
  if (window.KSBrandTracker || !window.IntersectionObserver) return;
  const config = window.KSBrandTrackingConfig || {};
  if (config.isThemeEditor) return;
  const pageViewId = "ks-pv-" + Date.now() + "-" + Math.random().toString(36).slice(2, 12);
  const stats = { published: 0, rejected: 0 };
  const states = new Map();
  const seen = new Set();
  let sequence = 0;
  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function visible(node) {
    if (!node.isConnected || document.visibilityState !== 'visible') return false;
    const style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility === 'visible' && Number(style.opacity) > 0;
  }
  function payload(block) {
    return {
      schema_version: '1',
      theme_id: config.themeId || 'unknown',
      environment: config.environment || 'qa',
      page_view_id: pageViewId,
      block_id: block.dataset.ksPromo,
      brand_id: block.dataset.ksPromoBrand,
      creative_id: block.dataset.ksPromoCreative || 'control',
      placement_id: block.dataset.ksPromoPlacement || 'unknown',
      page_type: block.dataset.ksPageType || 'unknown',
      viewport_band: window.innerWidth < 768 ? 'small' : 'large'
    };
  }
  function emit(name, data) {
    if (!allowed() || document.visibilityState !== 'visible') return false;
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return false;
    try {
      const result = publish.call(window.Shopify.analytics, name, {
        ...data, event_id: 'ks-' + Date.now() + '-' + (++sequence)
      });
      if (result && typeof result.catch === 'function') result.catch(() => { stats.rejected++; });
      if (result !== false) stats.published++;
      return result !== false;
    } catch (_) { return false; }
  }
  function cancel(state) {
    if (state.timer !== null) window.clearTimeout(state.timer);
    state.timer = null;
  }
  function schedule(state) {
    cancel(state);
    const key = state.block.dataset.ksPromo;
    if (seen.has(key) || !allowed() || state.ratio < 0.5 || !visible(state.target)) return;
    state.timer = window.setTimeout(function () {
      state.timer = null;
      if (!allowed() || state.ratio < 0.5 || !visible(state.target) || seen.has(key)) return;
      if (emit('ks:brand_impression', {
        ...payload(state.block), visible_ms: 1000, visible_ratio_threshold: 0.5
      })) seen.add(key);
    }, 1000);
  }
  const observer = new window.IntersectionObserver(entries => {
    for (const entry of entries) {
      const state = states.get(entry.target);
      if (!state) continue;
      state.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
      schedule(state);
    }
  }, { threshold: [0, 0.5, 1] });
  function scan() {
    for (const [target, state] of states) {
      if (!target.isConnected) { cancel(state); observer.unobserve(target); states.delete(target); }
    }
    document.querySelectorAll('[data-ks-promo][data-ks-promo-brand]').forEach(block => {
      if (!block.dataset.ksPromo || !block.dataset.ksPromoBrand) return;
      const target = block.querySelector('[data-ks-promo-view]') || block;
      if (states.has(target)) return;
      const state = { block, target, ratio: 0, timer: null };
      states.set(target, state); observer.observe(target);
    });
  }
  function refresh() { for (const state of states.values()) schedule(state); }
  function click(event) {
    const link = event.target.closest?.('a[data-ks-promo-element]');
    const block = link?.closest('[data-ks-promo][data-ks-promo-brand]');
    if (!block || !allowed()) return;
    let path;
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(pages|collections|products)(\/|$)/.test(url.pathname)) return;
      path = url.pathname; // No query strings, search terms, email, account URLs or fragments.
    } catch (_) { return; }
    emit('ks:brand_click', {
      ...payload(block), element_id: link.dataset.ksPromoElement,
      destination_path: path, had_qualified_impression: seen.has(block.dataset.ksPromo)
    });
  }
  document.addEventListener('click', click);
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', scan);
  const mutations = new window.MutationObserver(scan);
  mutations.observe(document.documentElement, { childList: true, subtree: true });
  window.KSBrandTracker = { scan, stats, themeId: config.themeId, environment: config.environment, consentAllowed: allowed, destroy() {
    for (const state of states.values()) cancel(state);
    states.clear(); seen.clear(); observer.disconnect(); mutations.disconnect();
    document.removeEventListener('click', click);
    document.removeEventListener('visitorConsentCollected', refresh);
    document.removeEventListener('visibilitychange', refresh);
    document.removeEventListener('shopify:section:load', scan);
    delete window.KSBrandTracker;
  } };
  scan();
  if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) refresh(); });
  }
})();
